"use client"

import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { clearError } from "../redux/slices/authSlice"
import LoginForm from "./LoginForm"
import RegisterForm from "./RegisterForm"
import ForgotPasswordForm from "./ForgotPasswordForm"
import HeaderBeforeLogin from "../layout/HeaderBeforeLogin"
import Footer from "../layout/Footer"
import VerifyOTP from "./VerifyOTPForm"

function AuthScreen() {
  const location = useLocation()
  const dispatch = useDispatch()
  const [currentView, setCurrentView] = useState("login")

  // Update view based on URL and clear errors
  useEffect(() => {
    // Clear any existing errors when navigating between auth views
    dispatch(clearError())

    const path = location.pathname
    if (path === "/register") {
      setCurrentView("register")
      document.title = "Register - KAXAA Wallet"
    } else if (path === "/forgot-password") {
      setCurrentView("forgot")
      document.title = "Forgot Password - KAXAA Wallet"
    } else if (path === "/verify-otp") {
      setCurrentView("verify-otp")
      document.title = "Verify OTP - KAXAA Wallet"
    } else {
      setCurrentView("login")
      document.title = "Login - KAXAA Wallet"
    }
  }, [location.pathname, dispatch])

  const renderForm = () => {
    switch (currentView) {
      case "login":
        return <LoginForm />
      case "register":
        return <RegisterForm />
      case "forgot":
        return <ForgotPasswordForm />
      case "verify-otp":
        return <VerifyOTP />
      default:
        return <LoginForm />
    }
  }

  return (
    <div className="d-flex flex-column h-full" style={{minHeight: '100vh'}}>
      <HeaderBeforeLogin />
      <div className="auth-screen flex-1 overflow-auto flex-col">
        <div className="auth-container">{renderForm()}</div>
        <Footer />
      </div>
    </div>
  )
}

export default AuthScreen
